import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoBox from 'components/InfoBox/InfoBox';
import StatusBullet from 'components/StatusBullet/StatusBullet';
import { Header, Info, Title } from 'components/Text';
import EnumObeStatus from 'constants/obeStatuses';
import { NOT_AVAILABLE } from 'constants/text';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import getObeStatusBullet from 'utils/obes/getObeStatusBullet';
import SwapHoriz from "@material-ui/icons/esm/SwapHoriz";
import { SecondaryButton } from 'components/Button';
import { useHistory } from 'react-router-dom';
import { SUBSCRIPTION_PLAN_CHANGE } from 'routes/overview/paths';
import { getSubscriptionPlanName } from 'utils/mapping/mapSubscriptionPlan';
import useStyles from '../TagDetailsStyles';
export default function TagInfo({
  tag
}) {
  const {
    t
  } = useTranslation();
  const {
    tagInfoElement,
    row
  } = useStyles();
  const {
    push
  } = useHistory();
  if (!tag) return /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('error.no_tag'));
  const {
    obeNumber,
    agreementName,
    obeStatus,
    updatedOn,
    replacedBy,
    replacementCompleted,
    subscriptionAmount,
    subscriptionPlanId,
    pendingSubscriptionChange
  } = tag;
  const updatedObeStatus = replacedBy && !replacementCompleted ? EnumObeStatus.BeingReplaced : obeStatus;
  const showSubscriptionButton = [EnumObeStatus.Active, EnumObeStatus.Frozen, EnumObeStatus.Inactive].includes(updatedObeStatus);
  const isActiveStatus = updatedObeStatus === EnumObeStatus.Active;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, t('tag.tag_subtitle')), /*#__PURE__*/React.createElement(Info, {
    className: tagInfoElement
  }, t('tag.tag_number'), ": ", obeNumber), /*#__PURE__*/React.createElement(Info, null, t('agreements.agreement'), ": ", agreementName || NOT_AVAILABLE), /*#__PURE__*/React.createElement(Info, null, t('subscriptions.subscription_plan'), ": ", t(`subscriptions.plans.${getSubscriptionPlanName(subscriptionPlanId)?.toLowerCase()}`) || NOT_AVAILABLE, pendingSubscriptionChange && pendingSubscriptionChange.effectiveDate && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', "(", t('subscriptions.changing_to_on_date', {
    newPlan: pendingSubscriptionChange.newSubscriptionPlanId ? t(`subscriptions.plans.${getSubscriptionPlanName(pendingSubscriptionChange.newSubscriptionPlanId)?.toLowerCase()}`) : '',
    effectiveDate: dateTimeFormatter(pendingSubscriptionChange.effectiveDate)
  }), ")")), /*#__PURE__*/React.createElement(Info, null, t('subscriptions.subscription'), ": ", subscriptionAmount, " NOK"), updatedObeStatus && /*#__PURE__*/React.createElement(Info, null, /*#__PURE__*/React.createElement(StatusBullet, {
    status: getObeStatusBullet[updatedObeStatus],
    text: t(`status.${updatedObeStatus.toLowerCase()}`, {
      replacedBy
    })
  })), showSubscriptionButton && /*#__PURE__*/React.createElement(Box, {
    className: row
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    startIcon: /*#__PURE__*/React.createElement(SwapHoriz, null),
    disabled: !isActiveStatus,
    onClick: () => isActiveStatus && push(SUBSCRIPTION_PLAN_CHANGE(tag?.obeNumber))
  }, t('buttons.change_subscription_plan')))), showSubscriptionButton && !isActiveStatus && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('subscriptions.inactive_subscription_warning'))), updatedObeStatus === EnumObeStatus.BeingReplaced && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('error.replaced', {
    replacementDate: dateTimeFormatter(updatedOn)
  }))));
}